import { render, staticRenderFns } from "./AddList.vue?vue&type=template&id=c3f87448&"
import script from "./AddList.vue?vue&type=script&lang=js&"
export * from "./AddList.vue?vue&type=script&lang=js&"
import style0 from "./AddList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports